'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (feis_id, isDeregistering) {
  return function (dispatch, getState) {
    dispatch({
      feis_id: feis_id,
      isDeregistering: isDeregistering,

      type: 'SET_CURRENT_DEREGISTERING_FLAG'
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/registrations/setDeregisteringFlag.js
// module id = 667
// module chunks = 0